(function(){
  var LABELS={'clearance':'Clearance','complete-set':'Complete Set','exclusive':'DCP Exclusive','staff-pick':'Staff Pick','new':'New'};
  var ORDER=['clearance','complete-set','exclusive','staff-pick','new'];
  var map=null,t=null;
  function handleFrom(card){var a=card.querySelector('a[href*="/products/"]');if(!a)return null;var m=a.getAttribute('href').match(/\/products\/([^\/?#]+)/);return m?m[1]:null;}
  function stamp(){
    if(!map)return;
    var cards=document.querySelectorAll('.spf-product-card:not([data-dcpb])');
    for(var i=0;i<cards.length;i++){
      var card=cards[i];card.setAttribute('data-dcpb','1');
      var h=handleFrom(card);if(!h)continue;
      var badges=map[h];if(!badges||!badges.length)continue;
      var inner=card.querySelector('.spf-product-card__inner')||card;
      var target=inner.querySelector('.dcp-badges');
      if(!target){target=document.createElement('div');target.className='dcp-badges';inner.insertBefore(target,inner.firstChild);}
      for(var j=0;j<ORDER.length;j++){var b=ORDER[j];if(badges.indexOf(b)>-1 && !target.querySelector('.dcp-badge--'+b)){var s=document.createElement('span');s.className='dcp-badge dcp-badge--'+b;s.textContent=LABELS[b];target.appendChild(s);}}
    }
  }
  function pdpMove(){return;/*disabled: PDP overlay retired*/
    if(!/template[_-]product/.test(document.body.className))return;
    var b=document.querySelector('.main-slider-wrapper .dcp-badges:not(.dcp-pdp-moved)');if(!b){var others=document.querySelectorAll('.dcp-badges:not(.dcp-pdp-moved)');for(var k=0;k<others.length;k++){others[k].style.display='none';}return;}
    var vp=document.querySelector('.yv-product-big-slider .flickity-viewport')||document.querySelector('.main-slider-wrapper .flickity-viewport');
    if(!vp)return;
    vp.appendChild(b);b.classList.add('dcp-pdp-moved');
  }
  function run(){stamp();pdpMove();}
  function schedule(){clearTimeout(t);t=setTimeout(run,100);}
  function init(){
    fetch(window.DCP_BADGE_MAP_URL).then(function(r){return r.json();}).then(function(d){map=d;stamp();}).catch(function(){});
    pdpMove();
    new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();